/**
 * Strings class for Time Off Reason status.
 */
export const TimeOffReasonStatus = {
    Active: "Active",
    Deleted: "Deleted"
};